import {
  CONFIG_OPTION_TOAST_ERROR
} from "common/toast";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { AsyncPaginate, wrapMenuList } from 'react-select-async-paginate';
import { components } from "react-select";
import { toast } from "react-toastify";
import { ceil } from "lodash";
import plansApi from "api/planApi";
import bannerApi from "api/bannerApi";

interface Option {
  label: string | any;
  value: string;
}
interface DropdownOptionProps {
  name?: string;
  listCheckedOption?: string | null;
  debounceTimeout?: number;
  onChangeSelect?: (params: Option) => void;
  isMulti?: boolean;
  placeholder?: string;
  isShowIconCheck?: boolean;
  hideSelectedOptions?: boolean;
  isAllOption?: boolean;
  isDisabled?: boolean,
  keywordSearch?: string,
  isClearable?: boolean,
  defaultParams?: any
}
const LIMIT = 30

const DropdownAsyncBannerPosition = ({
  name = "",
  listCheckedOption,
  debounceTimeout = 700,
  onChangeSelect,
  isMulti = false,
  placeholder,
  isShowIconCheck = false,
  hideSelectedOptions = true,
  isAllOption = false,
  isDisabled = false,
  keywordSearch = '',
  isClearable = true,
  defaultParams = {},
}: DropdownOptionProps) => {
  const { t, i18n } = useTranslation();
  const [isAllCheckedBanner, setIsAllCheckedBanner] = useState(false);

  const OPTION_ALL_DEFAULT = { label: t("All Filter"), value: "all" };

  const [options, setOptions] = useState([])

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  }

  const loadListBannerPosition = async ({
    page,
    limit,
    search
  }: {
    page: number
    limit: number
    search?: string
  }) => {
    let params: any = { page, limit, name: search, ...defaultParams };

    try {
      const { data: { items, pagination }, code } = await bannerApi.getBannerPositionList(params);
      if (!code && code !== 200) {
        return { success: false };
      }

      const dataBannerPositionOptions = items?.map((a: any) => {
        return ({
          value: (a?.id),
          label: (
            <div className="d-flex align-items-center gap-2">
              <div>
                {`${a?.name} - `} <small className="text-warning">{a?.positionCode}</small>
              </div>
            </div>
          ),
          data: a,
        })
      })
      return {
        code,
        dataBannerPositionOptions: dataBannerPositionOptions || [],
        lastPage: ceil(pagination?.total / pagination?.limit)
      };
    } catch (e) {
      return {};
    }
  }

  async function loadOptions(search: string, loadedOptions: any[], { page }: { page: number }) {
    const {
      code,
      dataBannerPositionOptions,
      lastPage
    } = await loadListBannerPosition({ page, limit: LIMIT, search });
    let dataBannerPositionOptionsFormat = dataBannerPositionOptions || [];

    if (code !== 200) {
      toast(`${t("Failed to load data")}`, CONFIG_OPTION_TOAST_ERROR);
      return {
        options: [],
        hasMore: false,
      };
    }
    let lastPageFormat = lastPage ? lastPage : 1;
    let options = dataBannerPositionOptionsFormat;

    setOptions(options)

    return {
      options: options,
      hasMore: lastPageFormat > page,
      additional: {
        page: page + 1,
      },
    };
  }
  useEffect(() => {
    if (keywordSearch) {
      setOptions([])
      loadOptions(keywordSearch, [], { page: 1 })
    }
  }, [keywordSearch]);

  const optionsMemo = useMemo(() => {
    return [...(isAllOption ? [OPTION_ALL_DEFAULT] : []), ...options];
  }, [JSON.stringify(options), isAllOption, i18n?.language]);

  useEffect(() => {
    if (((listCheckedOption as any)?.value === OPTION_ALL_DEFAULT.value || !(listCheckedOption as any)?.value) && isAllOption) {
      setOnChangeOption(OPTION_ALL_DEFAULT)
    }
  }, [i18n.language, isAllOption, JSON.stringify(listCheckedOption)]);

  return (
    <AsyncPaginate
      key={i18n.language}
      name={name}
      isMulti={isMulti}
      isClearable={isClearable}
      options={optionsMemo}
      debounceTimeout={debounceTimeout}
      value={listCheckedOption}
      loadOptions={loadOptions}
      placeholder={placeholder}
      className="dropdown-status-rounded"
      hideSelectedOptions={false}
      onChange={(e: any) => setOnChangeOption(e)}
      additional={{
        page: 1,
      }}
      closeMenuOnSelect={hideSelectedOptions}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base: any) => ({
          ...base,
          zIndex: 1051,
        }),
      }}
      isDisabled={isDisabled}
    />
  );
};

export default DropdownAsyncBannerPosition;
